import UploadFileIcon from '@mui/icons-material/UploadFile'
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
} from '@mui/material'
import { useState } from 'react'

import { pollApi } from 'hooks/api/userPoll'
import { Option } from 'types/option'

const options: Option[] = [
  { value: 1, label: 'version1' },
  //{ value: 2, label: 'version2' }, アンケート更新したら追加
]

// CSVを解析して string[] を返却
async function readCsvRows(file: File): Promise<string[]> {
  const text = await file.text()
  const userIDs = text
    .trim()
    .split(/\r?\n/)
    .slice(1) // ヘッダー行を除外
    .map((line) => line.split(',')[0])
  return userIDs
}

export default function PollUserSelect() {
  const [userIDs, setUserIDs] = useState<string[]>([])
  const [selectedVersion, setSelectedVersion] = useState(0)
  const [isSubmitted, setIsSubmitted] = useState(false)

  const handleFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return
    try {
      const parsedUserIDs = await readCsvRows(file)
      setUserIDs(parsedUserIDs)
    } catch {
      alert('CSVの解析に失敗しました: ')
    }
  }

  // userIDsとselectedVersionをRowsに入れてapiに渡す
  const handleSubmit = async () => {
    if (userIDs.length === 0 || selectedVersion === 0) {
      alert('ユーザーIDとバージョンを選択してください')
      return
    }

    setIsSubmitted(true)
    try {
      await pollApi().bulkCreate({ userIDs, version: selectedVersion })
      alert('アンケートの作成が完了しました！')
    } catch (error) {
      console.error(error)
      alert(`アンケートの作成に失敗しました`)
    }
  }

  return (
    <Box sx={{ marginTop: 2 }}>
      <Typography variant="h6">アンケート表示対象選択</Typography>
      <Paper variant="outlined" sx={paperStyle}>
        <Button
          component="label"
          variant="contained"
          startIcon={<UploadFileIcon />}
          sx={{ mr: 2 }}
        >
          CSVアップロード
          <input type="file" accept=".csv" hidden onChange={handleFile} />
        </Button>
        <Typography sx={{ fontSize: '12px', color: 'gray' }}>
          ※user_idの列を持つCSVを選択してください。
        </Typography>
      </Paper>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel id="version-label">バージョン</InputLabel>
        <Select
          labelId="version-label"
          label="バージョン"
          value={selectedVersion}
          onChange={(e) => setSelectedVersion(Number(e.target.value))}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button variant="contained" onClick={handleSubmit} disabled={isSubmitted}>
        作成
      </Button>
    </Box>
  )
}

const paperStyle = {
  p: 2,
  mb: 3,
  display: 'flex',
  alignItems: 'center',
  marginTop: 2,
}
